
import { Component, Vue } from 'vue-property-decorator'
import { Store } from 'vuex'
import { DsOpenHeader } from 'ds-open-header'
import { Location } from 'vue-router'

const CONSOLE_URL =
  process.env.NODE_ENV === 'development' || location.hostname.includes('.dev.')
    ? 'http://console.dev.datastory.com.cn'
    : 'https://console.datastory.com.cn'

interface IModule {
  id: string
  label: string
  icon?: string
  routeProps?: Location
  externalLink?: string
  roles?: RoleType[]
}

interface MenuOption {
  id: string
  label: string
  icon?: string
  path?: string
}

type RoleType = 'admin' | 'provider'

@Component({
  components: {
    DsOpenHeader,
  },
})
export default class App extends Vue {
  $store!: Store<VuexState>

  rightMenus: {
    name: string
    icon: string
    options: IModule[]
  }[] = [
    {
      name: '工具',
      icon: 'ds-icon-cube',
      options: [
        {
          id: 'audit',
          label: '操作日志',
          icon: 'ds-icon-article2',
          externalLink: `${CONSOLE_URL}/audit`,
        },
      ],
    },
    {
      name: '支持',
      icon: 'ds-icon-nav-wb-normal',
      options: [
        {
          id: 'docs',
          label: '文档中心',
          icon: 'ds-icon-pre-pic',
          externalLink: 'https://docs.datastory.com.cn/',
        },
      ],
    },
    {
      name: '费用',
      icon: 'ds-icon-kedanjia',
      options: [
        {
          id: 'OrderList',
          label: '购买记录',
          icon: 'ds-icon-article-time',
          externalLink: `${CONSOLE_URL}/expense/orders`,
        },
      ],
    },
  ]

  get username() {
    return this.$store.state.userData?.userName ?? ''
  }

  get isLoggedIn() {
    return !!this.$store.state.userData?.userName
  }

  get accountId() {
    return this.$store.state.userData?.userId ?? ''
  }

  get userInfo() {
    console.log('11', this.username, this.accountId)
    if (this.username && this.accountId !== '') {
      return {
        userName: this.username,
        userId: this.accountId,
      }
    }
    return null
  }

  get userMenuOptions() {
    const menuOptions: MenuOption[] = [
      {
        id: 'Account',
        label: '账号信息',
        icon: 'ds-icon-zhanghao',
        path: '/',
      },
      {
        id: 'Authentication',
        label: '实名认证',
        icon: 'ds-icon-yonghuxinxi',
      },
      {
        id: 'Members',
        label: '成员管理',
        icon: 'ds-icon-project-list-user',
        path: `${CONSOLE_URL}/iam`,
      },
    ]
    if (this.$store.getters.isAdmin) {
      return menuOptions
    } else {
      return menuOptions.filter((menuOption) => menuOption.id !== 'Authentication')
    }
  }

  get isDatastory() {
    return this.$route.name === 'AccountDetail' || this.$route.name === 'RegisterSuccess'
  }

  get headerLogo() {
    return this.isDatastory ? require('../assets/datastoryLogo.svg') : require('../assets/headerLogo.png')
  }

  async handleLogoutClick() {
    const { success, message } = await this.$ucProxy({
      url: '/user/logout',
    })
    if (success) {
      this.$store.commit('RESET_SESSION')
      this.$router.push({ name: 'Login' })
    }
  }

  handleLogoClick() {
    if (this.isDatastory) {
      window.location.href = 'https://www.datastory.com.cn'
      return
    }
    const url = process.env.NODE_ENV === 'development' || location.hostname.includes('.dev.')
        ? 'http://appstore.dev.datastory.com.cn/'
        : 'https://appstore.datastory.com.cn/'
    window.location.href = url
  }

  handleLoginClick() {
    const { redirect_url } = this.$route.query
    if (redirect_url && !redirect_url.includes('appstore.')) {
      const redirectUrl = `${redirect_url}?_from=${location.href}&_action=login`
      location.replace(redirectUrl)
    } else {
      this.$router.push({
        name: 'Login', 
        query: {
          redirect_url,
        }
      })
    }
  }

  handleUserMenuClick(menu: MenuOption) {
    if (menu.id === 'Authentication') {
      const type = this.$store.state.userData?.accountType
      if (type === 'customer') {
        this.$dsMessage('功能待开放')
        return
      }
      this.$router.push({
        name: 'Certificate',
        query: {
          redirect_url: window.location.href,
          type,
        },
      })
    }
  }
}
